export default __webpack_public_path__ + "static/media/Health.ba0be098.svg";